<template>
    <div class="overall-bg pb-0">
        <b-container>
            <b-row>
                <b-col>
                    <BacktoPage :goback="$router.back">
                    </BacktoPage>
                    <Headerlayout :headertext="$t('Quotes.newQuote')" :contenttext="$t('Quotes.newQuotePara')">
                    </Headerlayout>
                </b-col>
            </b-row>
        </b-container>
    </div>
    <div class="overall-bg pt-0">
        <b-container>
            <div class="form-white-bg">
                <div>
                    <b-row>
                        <b-col lg="7" md="6" sm="6" cols="12">
                            <div class="input-fields">
                                <b-row>
                                    <b-col lg="8" md="8" sm="8">
                                        <div class="field mt-3">
                                            <CustomDropdown :placeholder="'Select for a Quote number'"
                                                :label="$t('Quotes.patientQuote')" class="storecode" name="Store"
                                                id="Store" />
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>

                                    <div class="box mt-3 ms-3 me-3 pb-5">
                                        <p class="bold-heading ms-2 py-3">{{ $t('Quotes.patientQuote') }} <span
                                                class="icons pi pi-trash float-end pe-3" style="color: #ED6B5F"></span>
                                        </p>
                                        <div class="box-nested ps-3">
                                            <b-row>
                                                <b-col>
                                                    <p class="bold-heading pt-3">#Q458244JI<span
                                                            class=" icons pi pi-window-maximize float-end pe-3"
                                                            style="color: #3096FF"></span></p>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <div class="pb-3">
                                                        <p class="storecode">Quote log date<span
                                                                class="bold-heading ms-3">12
                                                                DEC
                                                                2022</span>
                                                        </p>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>

                                </b-row>
                                <b-row>
                                    <b-col lg="6" md="8" sm="8">
                                        <div class="field mt-3">
                                            <TextField :rules="{ required: true }" :required-icon="false" name="ID"
                                                id="QUOTE_ID" :label="'QUOTE ID'" />
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="6" md="8" sm="8">
                                        <div class="field">
                                            <TextField :rules="{ required: true }" :required-icon="false" name="ID"
                                                id="QUOTE_ID" label="PI ID" />
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="6" md="8" sm="8">
                                        <div class="field">
                                            <CustomDropdown :placeholder="'Select for Supplier'"
                                                :label="$t('5005.choosesupppier')" class="storecode" name="Store"
                                                id="Store" />
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col lg="5" md="6" sm="6" cols="12">

                            <div class="image-upload">
                                <b-row>
                                    <b-col lg="9" md="9" sm="9" cols="12">
                                        <div class="me-2 my-5">
                                            <label class="bold-heading">{{ $t('PO.POCreation.UploadQuotes') }}</label>
                                            <FileUpload uploadoption="imageupload" class="mt-3"></FileUpload>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div>
                    <p class="common-heading1 mt-3">{{ $t('Quotes.productReqs') }}</p>
                    <b-row>
                        <ETableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll"
                            :columns="DetailsTableheaders" :globalFilterFields="globalFilterFields" :data="items"
                            :seriaNlumber=true>
                            <template v-slot:Add>
                                <span>
                                    <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                                </span>
                            </template>


                            <template v-slot:paymentslot="{ data }">


                                <div class="label-d-none tablefield mb-0">
                                    <CustomDropdown :items="data.SupplierOptionsWOR" v-model="data.supplierIdwo">
                                    </CustomDropdown>
                                </div>
                            </template>
                            <template v-slot:deliveryslot="{ data }">


                                <div class="label-d-none tablefield mb-0">
                                    <CustomDropdown :items="data.SupplierOptionsWOR" v-model="data.supplierIdwo">
                                    </CustomDropdown>
                                </div>
                            </template>

                            <template v-slot:CQty="{ data }">
                                <div class="label-d-none tablefield mb-0">
                                    <TextField type="text" placeholder="" clearable name=""
                                        id="$t('userManagement.branch.branchCode')" @keyup="
                                           
                                            " label="" v-model="data.ItemQuantity"
                                        :rules="{ required: false, numeric: true }" :requiredIcon="false"
                                        :disabled="data.IsConsigneeItem == 1 ? true : false" />
                                </div>
                            </template>
                            <template v-slot:FQty="{ data }">
                                <div class="label-d-none tablefield mb-0">
                                    <TextField type="text" placeholder="" clearable name=""
                                        id="$t('userManagement.branch.branchCode')" @keyup="
                                           
                                            " label="" v-model="data.ItemQuantity"
                                        :rules="{ required: false, numeric: true }" :requiredIcon="false"
                                        :disabled="data.IsConsigneeItem == 1 ? true : false" />
                                </div>
                            </template>
                            <template v-slot:Urate="{ data }">
                                <div class="label-d-none tablefield mb-0">
                                    <TextField type="text" placeholder="" clearable name=""
                                        id="$t('userManagement.branch.branchCode')" @keyup="
                                           
                                            " label="" v-model="data.ItemQuantity"
                                        :rules="{ required: false, numeric: true }" :requiredIcon="false"
                                        :disabled="data.IsConsigneeItem == 1 ? true : false" />
                                </div>
                            </template>
                            <template v-slot:Tax="{ data }">
                                <div class="label-d-none tablefield mb-0">
                                    <TextField type="text" placeholder="" clearable name=""
                                        id="$t('userManagement.branch.branchCode')" @keyup="
                                           
                                            " label="" v-model="data.ItemQuantity"
                                        :rules="{ required: false, numeric: true }" :requiredIcon="false"
                                        :disabled="data.IsConsigneeItem == 1 ? true : false" />
                                </div>
                            </template>
                            <template v-slot:LC="{ data }">
                                <div class="label-d-none tablefield mb-0">
                                    <TextField type="text" placeholder="" clearable name=""
                                        id="$t('userManagement.branch.branchCode')" @keyup="
                                           
                                            " label="" v-model="data.ItemQuantity"
                                        :rules="{ required: false, numeric: true }" :requiredIcon="false"
                                        :disabled="data.IsConsigneeItem == 1 ? true : false" />
                                </div>
                            </template>
                            <template v-slot:action="{ data }">
                                <!-- <span>
                                    <EditIcon @click="IsItemEdit(data)" />
                                    <DeleteIcon @click="IsItemDelete1(data)" />
                                </span> -->
                            </template>
                        </ETableview>
                    </b-row>
                    <b-row>
                        <div class="save-button mb-4">
                            <Cancel class="ms-4" @canclebtn="$emit('cancel')" />
                            <SaveButton label="Save" :cancelhide="false" />

                        </div>
                    </b-row>
                </div>


            </div>
        </b-container>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import SaveButton from "../../../../../../components/GeneralButtons/SaveButton.vue";
import Cancel from '../../../../../../components/GeneralButtons/CancelButtton.vue'
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import FileUpload from  "../../../../../../modules/Inventory/components/MasterCreation/FileUpload.vue";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import ETableview from "../../../../../../components/FormComponents/EditableTable.vue";
import CustomMultiSelect from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import SupplierMasterservice from "../../../../Service/SupplierMaster";

export default defineComponent({
    components: {
        CustomMultiSelect,
        Headerlayout,
        BacktoPage,
        Tableview,
        CustomDropdown,
        FileUpload,
        SaveButton,
        Cancel,
        TextField,
        ETableview
    },
    setup() {
        let items = ref([
            { RowNumber: 1, Req: 10, ID: 1001, free: 5, unitcost: 10, Discount: 2, Tax: 1, Totalvalue: 100 },
            { RowNumber: 2, Req: 15, ID: 1002, free: 3, unitcost: 12, Discount: 1, Tax: 1, Totalvalue: 150 },
            { RowNumber: 3, Req: 20, ID: 1003, free: 8, unitcost: 8, Discount: 3, Tax: 2, Totalvalue: 160 }

        ])
        const { t } = useI18n();

        const DetailsTableheaders = [
            {
                header: "Name",
                field: "Itemname1",
                slot: "Itemname1",
                sortable: false,
                fieldDisplay: "false",
                bodyclass: "boldclass text_overflow2",
                class: "mediumwidth",
            },

            {
                header: "Req Qty",
                // field: "Req",
                slot: "Qty",

                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Committed Qty",
                // field: "ID",
                slot: "CQty",

                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: 'width60',
            },
            {
                header: "Free",
                // field: "free",
                slot: "FQty",
                bodyclass: "right_td",
                class: "smallwidth",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Unit cost",
                // field: "unitcost",
                slot: "Urate",

                bodyclass: "right_td",
                class: "smallwidth"
            },
            // {
            //     header: "Discount",
            //     field: "Discount",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            // },
            {
                header: "Tax",
                // field: "Tax",
                slot: "Tax",

                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Landing Cost",
                // field: "Totalvalue",
                slot: "LC",

                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "right_td",
                class: "smallwidth"
            },

            {
                header: "Delivery Terms",
                // field: "Discount",
                slot: "deliveryslot",

                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth"
            },
            // {
            //     header: "Tax",
            //     field: "Tax",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            // },
            {
                header: "Payment Terms",
                slot: "paymentslot",
                // field: "Totalvalue",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth"

            },
        ]
        const globalFilterFields = ref(DetailsTableheaders.map((col) => col.field));
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            TaxName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxType: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxSubType: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
            ActiveStatus: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
        };
        var supcategory = ref();


        async function suppliercategorydd() {
            debugger;
            try {
                const dataresponse = await SupplierMasterservice.GetSuppliersByStoreId(
                    // props.commonItemProps.storeId ?? 0, BranchId
                    0, 0
                );
                console.log(dataresponse);
                supcategory.value = dataresponse["result"]
                    .filter((i1) => i1.IsActive == true)
                    .map((item: any) => {
                        item.name = item.Name;
                        item.value = item.Id;
                        return item;
                    });
            } catch (error) {
                console.log(error);
            }
        }
        onMounted(() => {
            suppliercategorydd()
        })
        return {
            items,
            DetailsTableheaders,
            globalFilterFields,
            filters,
        }
    }
})
</script>
<style scoped>
.common-heading {
    font-size: 18px;
    font-weight: 500;
}

.save-button {
    display: flex;
    justify-content: flex-end;
}

.box {
    background-color: #FEECDE;
    border-radius: 10px;
    width: 50%;
}

.box-nested,
.box-nested2 {
    background-color: #FFFFFF;
    border-radius: 10px;
}



.box-nested2 {
    border: 1px solid #b1abab;
}

.box-heading {
    justify-content: space-around;
    padding-top: 5%;
}

/* .quote-form {
    display: flex;
    justify-content: space-evenly;
} */
</style>